import {CollageLazy} from 'app/components/multimedia/gallery/collage/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

import {shouldSkipLazyLoad} from './shouldSkipLazyLoad';

export function defineMultimediaCollage(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-collage')) {
        return;
    }

    customElements.define(
        'gem-multimedia-collage',
        class extends WebComponentLoader {
            reactLazyComponent = CollageLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoad;
        },
    );
}
